import { render, staticRenderFns } from "./positionShen.vue?vue&type=template&id=54897fe8&scoped=true"
import script from "./positionShen.vue?vue&type=script&lang=js"
export * from "./positionShen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54897fe8",
  null
  
)

export default component.exports